// @generated by protoc-gen-connect-query v2.3.1 with parameter "target=ts"
// @generated from file travplaces/v1/admin_taxonomy.proto (package travplaces.v1, syntax proto3)
/* eslint-disable */

import { AdminTaxonomyService } from "./admin_taxonomy_pb";

/**
 * ── route styles ──────────────────────────────────────────────────
 *
 * @generated from rpc travplaces.v1.AdminTaxonomyService.CreateRouteStyle
 */
export const createRouteStyle = AdminTaxonomyService.method.createRouteStyle;

/**
 * @generated from rpc travplaces.v1.AdminTaxonomyService.UpdateRouteStyle
 */
export const updateRouteStyle = AdminTaxonomyService.method.updateRouteStyle;

/**
 * @generated from rpc travplaces.v1.AdminTaxonomyService.DeleteRouteStyle
 */
export const deleteRouteStyle = AdminTaxonomyService.method.deleteRouteStyle;

/**
 * ── route themes ──────────────────────────────────────────────────
 *
 * @generated from rpc travplaces.v1.AdminTaxonomyService.CreateTheme
 */
export const createTheme = AdminTaxonomyService.method.createTheme;

/**
 * @generated from rpc travplaces.v1.AdminTaxonomyService.UpdateTheme
 */
export const updateTheme = AdminTaxonomyService.method.updateTheme;

/**
 * @generated from rpc travplaces.v1.AdminTaxonomyService.DeleteTheme
 */
export const deleteTheme = AdminTaxonomyService.method.deleteTheme;

/**
 * ── categories ────────────────────────────────────────────────────
 *
 * @generated from rpc travplaces.v1.AdminTaxonomyService.CreateCategory
 */
export const createCategory = AdminTaxonomyService.method.createCategory;

/**
 * @generated from rpc travplaces.v1.AdminTaxonomyService.UpdateCategory
 */
export const updateCategory = AdminTaxonomyService.method.updateCategory;

/**
 * @generated from rpc travplaces.v1.AdminTaxonomyService.DeleteCategory
 */
export const deleteCategory = AdminTaxonomyService.method.deleteCategory;

/**
 * ── category groups ───────────────────────────────────────────────
 *
 * @generated from rpc travplaces.v1.AdminTaxonomyService.CreateCategoryGroup
 */
export const createCategoryGroup = AdminTaxonomyService.method.createCategoryGroup;

/**
 * @generated from rpc travplaces.v1.AdminTaxonomyService.UpdateCategoryGroup
 */
export const updateCategoryGroup = AdminTaxonomyService.method.updateCategoryGroup;

/**
 * @generated from rpc travplaces.v1.AdminTaxonomyService.DeleteCategoryGroup
 */
export const deleteCategoryGroup = AdminTaxonomyService.method.deleteCategoryGroup;
